export default __webpack_public_path__ + "static/media/office2-afterA-2048w.d3eebe35.png";